import { Component } from 'react';
import PropTypes from 'prop-types';
import { TweenLite } from 'gsap';

class BottomText extends Component {
  componentDidMount() {
    this.tween = TweenLite.to(this.containerElement, 2, {
      opacity: 1,
      paused: true
    });
  }

  componentDidUpdate(prevProps) {
    if (this.tween) {
      if (prevProps.paused && !this.props.paused) {
        this.tween.resume();
      } else if (!prevProps.paused && this.props.paused) {
        this.tween.pause();
      }
    }
  }

  componentWillUnmount() {
    this.tween.kill();
  }

  setRef = element => {
    this.containerElement = element;
  };

  render() {
    return this.props.markupFunc('BottomText', this.props.text, this.setRef);
  }
}

BottomText.propTypes = {
  markupFunc: PropTypes.func.isRequired,
  paused: PropTypes.bool.isRequired,
  text: PropTypes.node.isRequired
};

export default BottomText;



// WEBPACK FOOTER //
// ../core/src/components/Slideshow/textTypes/BottomText.js